(ns app.front.view.group.admin.form-schemas.form-mock-data
  "Mock data for displaying the mock up of a form in the admin form editor"
  (:require [app.front.view.sign-off :as sign-off]))


(defn- mock-party-role [role-key role-label]
  {:party-role/key   role-key
   :party-role/names [{:entity/language       :en
                       :localized-string/text role-label}]})


(def mock-data-ctx
  {;; :sign-off/parties
   ::sign-off/parties       [{:full-name             "Firstname Lastname"
                              :street-address        "Some address"
                              :postal-code           "12300"
                              :municipality-province "City of Town"
                              :sign-off-roles        [(mock-party-role :role/applicant "Applicant")]}
                             {:full-name             "John Smith"
                              :street-address        "Another address"
                              :postal-code           "32100"
                              :municipality-province "City of Town"
                              :sign-off-roles        [(mock-party-role :role/agent "Agent")]}]
   ;; :sign-off.rezoning/pre-consultation-information
   ::sign-off/information   {:category-name              {:value "Category"}
                             :current-use-of-building    {:value "Landfill"}
                             :description-of-work        {:value "Addition"}
                             :existing-land-use          {:value "Parking lot"}
                             :lot-con                    {:value "3"}
                             :plan-number                {:value "23"}
                             :postal-code                {:value "11000"}
                             :pre-consultation-completed {:value 1596263300000}
                             :property/id                {:value "1212331432432"}
                             :property/legal             {:value "SOME STREET"}
                             :proposed-development       {:value "2 houses"}
                             :proposed-use-of-building   {:value "Housing"}
                             :site-area                  {:value "7"}
                             :unit-number                {:value "123"}
                             :work-target-name           {:value "Target"}
                             :work-type-name             {:value "Type"}
                             :workspace/address          {:value "Some street"}
                             :workspace/id               {:value "WS-2020-123-A"}}
   ;; :sign-off/subject-land-information
   ::sign-off/properties    [{:property/id    "123"
                              :property/legal "legal"
                              :address        "Some street"
                              :primary        true}]
   ;; :sign-off/signatures
   ::sign-off/get-principal (constantly {:full-name "Firstname Lastname"})
   ::sign-off/permit-type   :permit-type/P
   :form                    {:form/party {:party/user {:user/first-name     "Firstname"
                                                       :user/last-name      "Lastname"
                                                       :user/street-address "123 Test Street"
                                                       :user/postal-code    "A1B 2C3"
                                                       :user/municipality   "Testville"}}}
   :lang                    :en
   :required-roles          [(mock-party-role :role/applicant "Applicant")
                             (mock-party-role :role/agent "Agent")
                             (mock-party-role :role/property-owner "Property owner")]
   :sign-off-pdf            {:db/id         0
                             :file/filename "mock.pdf"}})
